import { H2, SmallButton } from "@sellar-io/components";
import { PriceTierDiscountType } from "@sellar-io/api-v2/types";
import { getDiscountDescription } from "@sellar-io/common";
import { List, ListElement } from "../../../../components";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { useState } from "react";
import { PriceTierDiscountDialogCreate } from "./PriceTierDiscountDialog/PriceTierDiscountDialogCreate";
import { PriceTierDiscountDialogUpdate } from "./PriceTierDiscountDialog/PriceTierDiscountDialogUpdate";

export const PriceTierDiscountsEdit = ({
  priceTierId,
  volumeDiscountsId,
  discounts,
}: {
  priceTierId: number;
  volumeDiscountsId: number | null;
  discounts: PriceTierDiscountType[];
}) => {
  const [dialogActive, setDialogActive] = useState(false);

  return (
    <div className={"flex flex-col gap-2"}>
      <H2>Volume Discounts</H2>
      {!discounts.length ? (
        <div>No volume discounts</div>
      ) : (
        <List>
          {discounts.map((discount) => (
            <PriceTierDiscountListElement
              discount={discount}
              key={discount.id}
            />
          ))}
        </List>
      )}

      <PriceTierDiscountDialogCreate
        priceTierId={priceTierId}
        volumeDiscountsId={volumeDiscountsId}
        active={dialogActive}
        onDismiss={() => setDialogActive(false)}
      />

      <SmallButton
        onClick={() => {
          setDialogActive(true);
        }}
      >
        Add volume discount
      </SmallButton>
    </div>
  );
};

const PriceTierDiscountListElement = ({
  discount,
}: {
  discount: PriceTierDiscountType;
}) => {
  const { business } = useSellarCurrentBusiness();
  const [editDialogActive, setEditDialogActive] = useState(false);

  const currency = business?.Supplier?.currency;
  const discountDescription = getDiscountDescription({ discount, currency });

  return (
    <>
      <ListElement
        promptText={"Edit"}
        onClick={() => {
          setEditDialogActive(true);
        }}
      >
        {discountDescription}
      </ListElement>
      <PriceTierDiscountDialogUpdate
        priceTierDiscount={discount}
        active={editDialogActive}
        onDismiss={() => setEditDialogActive(false)}
      />
    </>
  );
};
